import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    id: String,
    label: String,
    dataset: String,
    column: String
  }

  connect() {
    this.element.style.display = 'none';
  }

  open() {
    this.element.style.display = 'block';
  }

  close() {
    this.element.style.display = 'none';
  }
} 